import React, { useState, useEffect } from 'react';
import { Activity } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SocialProofBar = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/public/stats`)
      .then(r => r.ok ? r.json() : null)
      .then(setStats)
      .catch(err => console.error('public/stats failed:', err));
  }, []);

  if (!stats) return null;
  const impressionsValue = stats.impressions_7d || stats.impressions_lifetime || 0;
  if (impressionsValue <= 0) return null;

  const items = [
    {
      key: 'impressions',
      icon: Activity,
      value: stats.impressions_7d > 0
        ? `${(stats.impressions_7d / 1000).toFixed(1)}K`
        : `${(stats.impressions_lifetime / 1000).toFixed(0)}K`,
      label: stats.impressions_7d > 0 ? 'impressions last 7 days' : 'impressions delivered',
    },
  ];

  return (
    <div className="bg-navy/5 border-y border-navy/10" data-testid="social-proof-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-center text-center">
          {items.map((it) => (
            <div key={it.key} className="flex items-center gap-2 sm:gap-3">
              <it.icon className="text-navy/60 hidden sm:block" size={20} />
              <div>
                <div className="text-lg sm:text-2xl font-bold text-navy leading-tight">{it.value}</div>
                <div className="text-[10px] sm:text-xs uppercase tracking-wider text-navy/60">{it.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SocialProofBar;
